<template>
  <v-row no-gutters>
    <v-card class="px-4" flat style="min-height: 700px; width: 100%">
      <div :class="isMobileBreakpoint ? 'pa-3' : ''">
        <v-input
          ref="autoCompleteInput"
          hide-details="auto"
          class="py-4 px-2 search-videos-input"
          prepend-inner-icon="panda-search"
          v-model="searchQuery"
          :placeholder="
            $t('message.pages.pandaAssist.createModal.searchPlaceholder')
          "
        ></v-input>
        <template v-if="showPath">
          <div class="videos-filter--path">
            <small v-for="(item, i) in breadcrumbArray" :key="i">
              <button
                type="button"
                @click="handleBackTo(item)"
                style="height: 32px"
              >
                <span :class="i === 0 ? 'body-bold-small' : 'textType6--text'">
                  <v-icon
                    v-if="i === 0 && breadcrumbArray.length > 1"
                    class="tableArrow"
                    size="16"
                    color="grey"
                    style="cursor: pointer"
                  >
                    mdi-arrow-left
                  </v-icon>
                  {{
                    item.id
                      ? item.name
                      : $t('message.pages.pandaAssist.createModal.library')
                  }}
                  <span
                    class="textType6--text px-1"
                    v-if="i < breadcrumbArray.length - 1"
                  >
                    /
                  </span>
                </span>
              </button>
            </small>
            <small>
              <v-icon v-if="!!selectedFolder">mdi-chevron-right</v-icon>
              <button
                v-if="!!selectedFolder"
                type="button"
                class="primary--text"
              >
                <span class="breadcrumbTexts primary--text">
                  {{ selectedFolder.name }}
                </span>
              </button>
            </small>
          </div>
        </template>
        <v-row
          v-if="showPath && filteredItems.length > 0"
          class="videos-filter--table-header"
          no-gutters
        >
          <v-col cols="auto" class="d-flex align-center justify-start ml-2">
            <v-simple-checkbox
              :indeterminate="checkboxIndeterminateStatus"
              :value="areAllSelected"
              :ripple="false"
              @input="toggleSelectAll"
              hide-details
            />
          </v-col>
          <v-col cols="8" class="d-flex align-center justify-start px-2">
            <v-row no-gutters>
              <div class="d-flex align-center">
                <span class="body-label--xs">
                  {{ $t('message.pages.videosDataTable.header.name') }}
                </span>
              </div>
            </v-row>
          </v-col>
          <v-spacer></v-spacer>
          <v-col
            cols="auto"
            class="d-flex align-center justify-end px-2"
            :class="{ 'mr-2': isEnglishLanguage }"
          >
            <span class="body-label--xs">
              {{ $i18next.t('message.pages.videosDataTable.header.time') }}
            </span>
          </v-col>
        </v-row>
        <vue-virtual-table
          v-if="filteredItems.length > 0"
          ref="dataTableContent"
          class="data-table__content videos-filter--table-content"
          :config="headers"
          :data="filteredItems"
          :height="tableHeight"
          :itemHeight="48"
          :minWidth="766"
        >
          <template slot="rowOverlay" slot-scope="scope">
            <v-col
              class="row-click-overlay"
              @click="handleItemClick(scope.row)"
              cols="auto"
            ></v-col>
          </template>
          <template slot-scope="scope" slot="select">
            <v-col
              cols="auto"
              class="d-flex align-center justify-start table-content--checkbox pa-0 ml-2"
            >
              <v-simple-checkbox
                color="primary"
                :ripple="false"
                :disabled="checkVideoSelected(scope)"
                :value="checkIfSelected(scope.row)"
                @input="checkboxSelection(scope.row)"
              ></v-simple-checkbox>
            </v-col>
          </template>
          <template slot-scope="scope" slot="titleCommon">
            <v-col
              cols="auto"
              class="d-flex align-center justify-start table-content--item-name flex-nowrap pa-0"
            >
              <v-icon class="folderIcon ml-2" v-if="scope.row.name" size="16">
                mdi-folder
              </v-icon>
              <v-icon v-else class="ml-2 videoIcon" size="16">
                panda-video
              </v-icon>
              <span
                class="textType6--text ml-2 truncate"
                :title="scope.row.name ? scope.row.name : scope.row.title"
                v-html="
                  highlightMatch(
                    scope.row.name ? scope.row.name : scope.row.title
                  )
                "
              ></span>
              <span
                v-if="scope.row.videos_count"
                class="ml-2 body-regular-smaller folder-videos-count"
                >({{ scope.row.videos_count }})</span
              >
            </v-col>
          </template>
          <template slot-scope="scope" slot="durationCommon">
            <v-col
              cols="auto"
              class="table-content--item-duration body-regular-smaller px-2"
            >
              <span v-if="scope.row.name">
                {{
                  folderData.get(scope.row.id)
                    ? folderData.get(scope.row.id).length
                      ? formatTime(folderData.get(scope.row.id).length)
                      : '00:00'
                    : '...'
                }}
              </span>
              <span v-else>
                {{
                  scope.row.length ? formatDuration(scope.row.length) : '00:00'
                }}
              </span>
            </v-col>
          </template>
        </vue-virtual-table>
        <div
          v-else
          style="height: 450px"
          class="empty-state d-flex align-center justify-center"
        >
          <span style="display: grid; justify-items: center">
            <p class="body-regular-base d-flex justify-center mb-2">
              {{
                showPath
                  ? $t('message.pages.pandaAssist.createModal.noItemsFoundAdd')
                  : $t('message.pages.pandaAssist.createModal.noItemsFound')
              }}
            </p>

            <p
              style="text-align: center"
              v-html="
                showPath
                  ? $t(
                      'message.pages.pandaAssist.createModal.noItemsFoundDescriptionAdd'
                    )
                  : $t(
                      'message.pages.pandaAssist.createModal.noItemsFoundDescription'
                    )
              "
              class="body-regular-small textType6--text"
            ></p>
            <base-btn
              v-if="!showPath"
              type="tertiary"
              size="small"
              @click="
                () => {
                  searchQuery = ''
                  applyFilter('')
                }
              "
              >{{
                $t('message.pages.pandaAssist.createModal.cleanSearch')
              }}</base-btn
            >
          </span>
        </div>
      </div>
    </v-card>
  </v-row>
</template>

<script>
import VueVirtualTable from 'vue-virtual-table'
import { mapState, mapMutations } from 'vuex'
import _ from 'lodash'
import formatTimeMixin from '@/utils/formatTime.mixins.js'
import videosApi from '@/services/videosApi'

export default {
  name: 'VideosFilterTable',
  components: {
    VueVirtualTable,
  },
  props: {
    dialogVisible: {
      type: Boolean,
      required: true,
    },
    isUpdateVideos: {
      type: Object,
      required: false,
    },
    video_external_id: {
      type: [Number, String],
      default: '',
      required: false,
    },
    video_external: {
      type: Object,
    },
  },
  data() {
    return {
      internalDialogVisible: this.dialogVisible,
      searchQuery: '',
      fixedDateTime: null,
      isLoading: false,
      alreadySelectedItem: [],
      filteredItems: [],
      showPath: true,
      allVideos: [],
      allAccountVideos: [],
      totalMinutes: 0,
      lastFolder: {
        name: '',
        id: null,
        parent_folder_id: null,
      },
      selectedFolder: null,
      searchFuseOptions: {
        keys: ['title', 'name', 'id', 'video_external_id', 'description'],
        includeScore: true,
        threshold: 0.4,
      },
      name: '',
      folderData: new Map(),
      purchaseOverviewData: [],
      flatItemList: [],
      suggestionEnabled: true,
      headers: [
        {
          prop: '_action',
          name: 'rowOverlay',
          width: 0,
          actionName: 'rowOverlay',
        },
        {
          prop: '_action',
          name: 'action',
          actionName: 'select',
          alignItems: 'center',
          justifyContent: 'start',
        },
        {
          prop: '_action',
          name: 'title',
          actionName: 'titleCommon',
          alignItems: 'center',
          justifyContent: 'start',
        },
        {
          prop: '_action',
          name: 'goInto',
          actionName: 'durationCommon',
          alignItems: 'center',
          justifyContent: 'end',
        },
      ],
      selectedVideos: [],
      selectedItems: [],
      breadcrumbArray: [{ name: '', id: null, parent_folder_id: null }],
    }
  },
  mixins: [formatTimeMixin],
  computed: {
    ...mapState('user', {
      folders: 'mainFolders',
      isMobileBreakpoint: 'isMobileBreakpoint',
    }),
    ...mapState({
      filterVideos: (state) => state.analytics.filters.filterVideos,
    }),
    isEnglishLanguage() {
      return this.$i18next.resolvedLanguage === 'en'
    },
    tableHeight() {
      let height = 500
      if (window.innerHeight < 850) {
        height = 450
      }
      if (window.innerHeight < 800) {
        height = 370
      }
      return height
    },
    reducedBreadcrumbArray() {
      let arrayMod = this.breadcrumbArray.filter((folder) => {
        return folder.id !== this.lastFolder.id
      })
      if (this.selectedFolder) {
        return this.breadcrumbArray
      }
      return arrayMod
    },
    areAllSelected() {
      const selectableItems = this.filteredItems.filter(
        (item) => !this.alreadySelectedItem.includes(item.id)
      )
      return (
        selectableItems.length > 0 &&
        selectableItems.every((item) =>
          this.selectedItems.some((selected) => selected.id === item.id)
        )
      )
    },
    checkboxIndeterminateStatus() {
      const selectableItems = this.filteredItems.filter(
        (item) => !this.alreadySelectedItem.includes(item.id)
      )
      const selectedCount = selectableItems.filter((item) =>
        this.selectedItems.some((selected) => selected.id === item.id)
      ).length

      return selectedCount > 0 && selectedCount < selectableItems.length
    },
    lastBreadcrumbItem() {
      return this.breadcrumbArray[this.breadcrumbArray.length - 1]
    },
    isNamesTooBig() {
      let size = 0
      for (let folder of this.breadcrumbArray) {
        size += folder.name.length
      }
      if (this.selectedFolder?.name) {
        size += this.selectedFolder.name.length
      }
      return size > 50
    },
    allItems() {
      return this.toBeSelectedFolders.concat(this.allVideos)
    },
    allItemsNotFiltered() {
      return this.toBeSelectedFoldersRoot.concat(this.allAccountVideos)
    },
    toBeSelectedFoldersRoot() {
      return this.folders
    },
    toBeSelectedFolders() {
      let selectedFolders = this.folders.filter((folder) => {
        return folder.parent_folder_id === this.lastFolder.id
      })
      return selectedFolders
    },
    selectedVideosToAnalyze() {
      const filteredSelectedItems = this.selectedItems.filter(
        (item) => !item.hasOwnProperty('videos_count')
      )
      return filteredSelectedItems
    },
  },
  beforeDestroy() {
    this.$root.$off('pandaAssistVideos')
    this.$root.$off('pandaAssistAddVideos')
  },
  async mounted() {
    await this.checkIfVideosAreLoaded()
    if (!window.db) {
      this.$root.$emit('initDexie')
    }
    this.flatItemList = await this.flattenAllItems()
    document.addEventListener('keydown', this.checkIfCtrlAWasPressed)
  },
  async created() {
    if (!window.db) {
      this.$root.$emit('initDexie')
    }
    this.getVideos()
    this.folderData = await this.getFolderSize(this.folders)
  },
  watch: {
    dialogVisible(newVal) {
      this.internalDialogVisible = newVal
    },
    step() {
      this.setFixedDateTime()
    },
    searchQuery(newQuery) {
      this.applyFilter(newQuery)
    },
    langOption() {
      this.$forceUpdate()
    },
    allItems: {
      immediate: true,
      handler(newItems) {
        this.filteredItems = newItems.filter(
          (item) =>
            item.status !== 'DELETING' &&
            item.status !== 'FAILED' &&
            item.status !== 'CONVERTING'
        )
      },
    },
    internalDialogVisible(newVal) {
      this.$emit('update:dialog-visible', newVal)
    },
    video_external_id() {
      this.filterByExternalID()
    },
    selectedItems: {
      handler(selectedItems) {
        if (selectedItems.length) {
          const selectedVideos = selectedItems.filter((item) =>
            item.hasOwnProperty('title')
          )
          if (selectedVideos.length)
            return this.$emit('emptyFolderSelected', false)
          if (!selectedVideos.length)
            return this.$emit('emptyFolderSelected', true)
        } else {
          return this.$emit('emptyFolderSelected', false)
        }
      },
    },
    selectedVideosToAnalyze: {
      handler(val) {
        this.$emit('selectedVideosToAnalyze', val)
      },
    },
    allAccountVideos: {
      handler(val) {
        this.$emit('allAccountVideos', val)
      },
    },
  },
  methods: {
    ...mapMutations('user', ['UPDATE_GLOBAL_SNACKBAR']),
    highlightMatch(text) {
      if (!this.searchQuery) return text
      const regex = new RegExp(`(${this.searchQuery})`, 'gi')
      return text.replace(regex, '<b class="neutral-20-dark--text">$1</b>')
    },
    checkIfCtrlAWasPressed(event) {
      if ((event.ctrlKey || event.metaKey) && event.key === 'a') {
        const inputElement =
          this.$refs.autoCompleteInput?.$el?.querySelector('input')
        if (inputElement && this.searchQuery.length > 0) {
          inputElement.select()
          event.preventDefault()
        }
      }
    },
    closeModal() {
      this.internalDialogVisible = false
      if (this.video_external && Object.keys(this.video_external).length)
        this.$emit('buyConfirm', true)
      this.resetModal()
    },
    checkVideoSelected(scope) {
      return this.video_external?.id == scope.row.id
    },
    setFixedDateTime() {
      if (!this.fixedDateTime) {
        const now = new Date()

        const locale = this.$i18n?.locale || this.$i18next?.language || 'pt-BR'

        const dateFormatter = new Intl.DateTimeFormat(locale, {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
        })

        const timeFormatter = new Intl.DateTimeFormat(locale, {
          hour: '2-digit',
          minute: '2-digit',
        })

        const formattedDate = dateFormatter.format(now)
        const formattedTime = timeFormatter.format(now)

        const translationMap = {
          'pt-BR': 'às',
          en: 'at',
          es: 'a las',
        }

        const atTranslation = translationMap[locale] || 'às'

        this.fixedDateTime = `${formattedDate} ${atTranslation} ${formattedTime}`
      }
    },

    async flattenAllItems() {
      let allItems = []
      allItems.push(...this.folders)
      const videos = await window.db.videos
        .filter(({ status }) => status !== 'DELETING')
        .toArray()
      allItems.push(...videos)

      if (this.filterVideos && this.filterVideos.selectedVideos) {
        const selectedVideosPromises = this.filterVideos.selectedVideos.map(
          async (video) => {
            const videoConfig = await window.db.videos
              .where({ id: video.videoId })
              .first()

            return videoConfig
          }
        )

        const selectedVideos = await Promise.all(selectedVideosPromises)

        this.selectedItems = [...selectedVideos]
      }

      return allItems
    },
    handleItemClick(item) {
      this.handleEnterFolder(item)
    },

    applyFilter(query) {
      const lowerQuery = query.toLowerCase()
      let items = this.allItemsNotFiltered
      const inputElement =
        this.$refs.autoCompleteInput?.$el?.querySelector('input')
      let cursorPosition = 0

      if (inputElement) {
        cursorPosition = inputElement.selectionStart
      }
      this.showPath = false
      if (!query) {
        items = this.allItems
        this.showPath = true
      }
      this.$nextTick(() => {
        if (inputElement) {
          inputElement.focus()
          inputElement.setSelectionRange(cursorPosition, cursorPosition)
        }
      })
      this.filteredItems = items.filter((item) => {
        const name = item.name ? item.name.toLowerCase() : ''
        const title = item.title ? item.title.toLowerCase() : ''

        if (item.status === 'CONVERTING') {
          return false
        }

        if (item.title) {
          return item.status === 'CONVERTED' && title.includes(lowerQuery)
        }

        if (item.name) {
          return name.includes(lowerQuery)
        }
        return false
      })
    },

    handleSelectedItem(item) {
      if (!this.checkIfSelected(item)) {
        this.selectedItems.push(item)
      }
    },

    handleFolderSelected(folder) {
      this.lastFolder = folder
      this.breadcrumbArray.push(folder)
    },

    async toggleSelectAll(isSelected) {
      let selectableItems = []

      if (this.lastFolder.id) {
        selectableItems = this.filteredItems.filter(
          (item) => !this.alreadySelectedItem.includes(item.id)
        )
      } else {
        selectableItems = this.flatItemList.filter(
          (item) => !this.alreadySelectedItem.includes(item.id)
        )
      }

      if (isSelected) {
        this.selectedItems = [
          ...new Set([...this.selectedItems, ...selectableItems]),
        ]
      } else {
        if (this.lastFolder.id) {
          this.selectedItems = this.selectedItems.filter(
            (item) =>
              !selectableItems.some((selectable) => selectable.id === item.id)
          )
        } else {
          this.selectedItems = []
        }
      }
    },

    formatDuration(seconds) {
      if (!seconds || seconds <= 0 || isNaN(seconds)) return ''

      const hrs = Math.floor(seconds / 3600)
      const mins = Math.floor((seconds % 3600) / 60)
      const secs = Math.floor(seconds % 60)

      if (hrs > 0) {
        return `${String(hrs).padStart(2, '0')}:${String(mins).padStart(
          2,
          '0'
        )}:${String(secs).padStart(2, '0')}`
      } else {
        return `${String(mins).padStart(2, '0')}:${String(secs).padStart(
          2,
          '0'
        )}`
      }
    },
    async getFolderSize(
      folders,
      isSub = false,
      id = null,
      data = new Map(),
      visitedFolders = new Set()
    ) {
      for (const folder of folders) {
        if (visitedFolders.has(folder.id)) continue

        visitedFolders.add(folder.id)

        const videosIn = await window.db.videos
          .where({ folder_id: folder.id })
          .and(({ status }) => status !== 'DELETING')
          .toArray()

        let fData = { size: 0, length: 0, cost: 0 }

        for (const { storage_size, length } of videosIn) {
          fData.size += storage_size
          fData.length += length
          fData.cost += Math.ceil(length / 60) // Calcula o custo arredondando para cima
        }

        if (!isSub) {
          data.set(folder.id, fData)
        } else {
          const parentData = data.get(id) || { size: 0, length: 0, cost: 0 }

          parentData.size += fData.size
          parentData.length += fData.length
          parentData.cost += fData.cost

          data.set(id, parentData)
        }

        // Recursivamente processa subpastas
        const subFolders = this.folders.filter(
          ({ parent_folder_id }) => parent_folder_id === folder.id
        )

        if (subFolders.length) {
          await this.getFolderSize(
            subFolders,
            true,
            id ?? folder.id,
            data,
            visitedFolders
          )
        }
      }

      return data
    },
    async checkIfVideosAreLoaded() {
      const allVideos = await window.db.videos.toArray()
      if (!allVideos.length) {
        const { data } = await videosApi.getAllVideosAndBin()
        const videosResponse = data.videos
        let filteredFoldersIds = []
        for (let folderId in videosResponse) {
          filteredFoldersIds.push(folderId)
        }
        await window.db.videos.clear()
        for (let folderId of filteredFoldersIds) {
          let arrToBeAdded = videosResponse[folderId].map((obj) => ({
            ...obj,
            folder_id: folderId,
          }))
          await window.db.videos.bulkPut(arrToBeAdded)
        }
      }
    },
    handleDialogClose(isVisible) {
      this.internalDialogVisible = isVisible

      if (!isVisible) {
        this.resetModal()
      }
    },
    toggleVideoSelection(videoId) {
      const index = this.selectedVideos.indexOf(videoId)
      if (index === -1) {
        this.selectedVideos.push(videoId)
      } else {
        this.selectedVideos.splice(index, 1)
      }
    },
    resetModal() {
      this.applyFilter('')
      this.searchQuery = ''
      if (this.isUpdateVideos?.id) {
        this.step = 5
        this.name = this.isUpdateVideos.name
        this.initialQuestion = this.isUpdateVideos.initial_question
        this.suggestionEnabled = true
        this.selectedVideos = this.isUpdateVideos.videos
        return
      }
      this.step = 0
      this.name = ''
      ;(this.initialQuestion = this.$t(
        'message.pages.pandaAssist.createModal.howCanIHelp'
      )),
        (this.suggestionEnabled = true)
      this.selectedVideos = []
      this.totalMinutes = 0
      this.selectedItems = []
    },
    async handleEmitAll() {
      this.selectedItems = []
      this.isShown = false
      this.$root.$emit('analyticsV2SearchAll')
    },
    async handleFilterSelected() {
      let videos = []
      let folders = []
      for (let item of this.selectedItems) {
        if (item.name) {
          folders.push(item)
        } else {
          videos.push(item)
        }
      }
      this.filteredVideos = [...videos]
      let result = await this.getAllItems(folders)
      this.filteredVideos = this.filteredVideos.concat(result)
      this.$root.$emit('filterSelected', this.filteredVideos)
      this.filteredVideos = []
      this.isShown = false
    },
    async getAllItems(folders) {
      let items = []
      for (let item of folders) {
        if (item.name) {
          let vids = await window.db.videos
            .where({ folder_id: item.id })
            .toArray()
          items = items.concat(vids)
          let children = this.folders.filter(
            (folder) => folder.parent_folder_id === item.id
          )
          if (children.length) {
            await this.getAllItems(children)
          }
        }
      }
      return items
    },
    async handleEnterFolder(item) {
      if (!item.name) {
        this.checkboxSelection(item)
      } else {
        this.allVideos = await window.db.videos
          .where({ folder_id: item.id })
          .toArray()

        let breadcrumbLocal = []

        const buildBreadcrumb = (folder) => {
          if (folder.parent_folder_id) {
            const parentFolder = this.folders.find(
              (f) => f.id === folder.parent_folder_id
            )
            if (parentFolder) {
              buildBreadcrumb(parentFolder)
            }
          }
          breadcrumbLocal.push(folder)
        }

        buildBreadcrumb(item)

        this.lastFolder = item
        this.breadcrumbArray = [
          { name: '', id: null, parent_folder_id: null },
          ...breadcrumbLocal,
        ]
        this.searchQuery = ''
        this.applyFilter('')
      }
    },
    checkIfHasChildren(folder) {
      let anySon = this.folders.find(
        (item) => item.parent_folder_id === folder.id
      )
      return anySon
    },
    async handleBackTo(backToFolder) {
      if (backToFolder.id) {
        this.allVideos = await window.db.videos
          .where({ folder_id: backToFolder.id })
          .toArray()
      } else {
        this.breadcrumbArray = [{ name: '', id: null, parent_folder_id: null }]
        this.getVideos()
      }
      this.selectedFolder = null
      this.lastFolder = backToFolder
      if (
        this.breadcrumbArray.length < 2 ||
        this.breadcrumbArray[this.breadcrumbArray.length - 1].id ===
          backToFolder.id
      )
        return
      let index = this.breadcrumbArray.findIndex((folder) => {
        return folder.id === backToFolder.id
      })
      let newArr = this.breadcrumbArray.slice(0, index + 1)
      this.breadcrumbArray = newArr
    },
    async getVideos() {
      this.allAccountVideos = await window.db.videos.toArray()
      this.allVideos = await window.db.videos
        .where({ folder_id: 'root' })
        .toArray()

      this.filterByExternalID()
    },
    checkIfSelected(item) {
      let foundItem = this.selectedItems.find((searchedVideo) => {
        return searchedVideo.id === item.id
      })
      if (foundItem) return true
      return false
    },
    async getAllItemsInFolder(folderId) {
      let items = []

      // Adiciona todos os vídeos diretamente na pasta
      const videos = await window.db.videos
        .where({ folder_id: folderId })
        .and(({ status }) => status !== 'DELETING')
        .toArray()
      items.push(...videos)

      // Busca subpastas
      const subFolders = this.folders.filter(
        (folder) => folder.parent_folder_id === folderId
      )

      // Recursivamente adiciona itens das subpastas
      for (const subFolder of subFolders) {
        const subItems = await this.getAllItemsInFolder(subFolder.id)
        items.push(...subItems)
      }

      return items
    },
    async checkboxSelection(item) {
      if (!item) return
      if (this.alreadySelectedItem.includes(item.id)) {
        return
      }

      const alreadySelected = this.checkIfSelected(item)

      if (item.name) {
        const allItemsInFolder = await this.getAllItemsInFolder(item.id)

        if (alreadySelected) {
          this.selectedItems = this.selectedItems.filter(
            (selectedItem) =>
              selectedItem.id !== item.id &&
              !allItemsInFolder.some((i) => i.id === selectedItem.id)
          )
        } else {
          const itemsToAdd = allItemsInFolder.filter(
            (i) => !this.checkIfSelected(i)
          )
          this.selectedItems = [...this.selectedItems, item, ...itemsToAdd]
        }
      } else {
        if (alreadySelected) {
          this.selectedItems = this.selectedItems.filter(
            (selected) => selected.id !== item.id
          )
        } else {
          this.selectedItems.push(item)
        }
      }
      this.selectedItems = [...new Set(this.selectedItems)]
    },
    async filterByExternalID() {
      if (!this.video_external_id) return

      const option = { video_external_id: this.video_external_id }

      const [videoInDB] = await window.db.videos.where(option).toArray()
      const videoInRoot = _.find(this.allVideos, option)

      let video

      if (videoInRoot) video = videoInRoot
      else {
        this.allVideos.push(videoInDB)
        video = videoInDB
      }

      this.selectedItems = [video]

      this.handleFilterSelected()
    },
  },
}
</script>

<style lang="scss">
.videos-filter--table-content {
  overflow-x: hidden !important;
  .item-cell:has(.table-content--checkbox) {
    flex: 0 0 auto !important;
  }
  .item-cell:has(.table-content--item-name) {
    flex: 0 0 66.6666666667% !important;
    max-width: 66.6666666667% !important;
  }
  .item-cell:has(.row-click-overlay) {
    flex: 0 !important;
    max-width: 0 !important;
  }
  /* the rows generated by vue-virtual-table */
  .item-line {
    position: relative;
  }

  .row-click-overlay {
    position: absolute;
    inset: 0;
    cursor: pointer;
  }
}
</style>

<style lang="scss" scoped>
@import '@/assets/scss/src/data-tableV2';
.search-videos-input {
  width: 100%;
}
.videos-filter--path {
  display: flex;
  align-items: center;
  height: 32px;
  padding-left: $spacing-03;
}

.videos-filter--table-header {
  height: 48px;

  .body-label--xs {
    color: varFigma(neutral-20-dark);
    font-family: Rubik;
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: 100%;
  }
}
.selected-video {
  background-color: #e0f7fa !important;
}

::v-deep .item-line {
  border-top: 1px solid varFigma(neutral-95-lightest) !important;
}

.truncate {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 280px;
  display: inline-block;
}

::v-deep .panda-search:before {
  font-size: 16px !important;
}

.base-input.v-input[data-v-36a1b07e] input::placeholder {
  font-weight: 400;
  font-size: 12px;
}

.v-dialog--fullscreen > .v-card {
  min-height: auto !important;
  min-width: 100%;
  margin: 0 !important;
  padding: 16px;
}

::v-deep .v-label {
  font-size: 14px !important;
  color: varFigma(neutral-40-light) !important;
}

::v-deep .t-header {
  display: none !important;
}

.tableArrow {
  color: varFigma(neutral-20-dark) !important;
}

.folderIcon {
  color: varFigma(neutral-70) !important;
}

.videoIcon {
  color: varFigma(brand-70) !important;
}

.videoIconNeutral {
  color: varFigma(neutral-70) !important;
}

.folder-videos-count {
  color: varFigma(neutral-40-light);
}
</style>
